/**
 * Placeholder for sections not yet implemented. Shows title + "Скоро".
 */

import { Layout } from "../../components/layout/index.ts";

interface SoonPageProps {
  title: string;
}

export function SoonPage({ title }: SoonPageProps) {
  return (
    <Layout>
      <div className="rounded-2xl overflow-hidden bg-white/95 shadow-sm p-8 xs:p-10 text-center">
        <p className="text-slate-400 text-sm font-medium uppercase tracking-wider mb-2">
          Скоро
        </p>
        <h1 className="text-xl xs:text-2xl font-bold text-slate-800">
          {title}
        </h1>
        <p className="text-slate-500 text-sm mt-4">Раздел в разработке</p>
      </div>
    </Layout>
  );
}
